// How a round's choices compare with the best and worst possible run.
// A question where every choice ends the same (invalid or flat) has no best
// or worst choice, so it never counts either way.
export type RunExtremes = {
  best: { actions: string[] };
  worst: { actions: string[] };
};

export function choiceTag(
  action: string,
  extremes: RunExtremes,
  index: number,
): "best" | "worst" | null {
  const best = extremes.best.actions[index];
  const worst = extremes.worst.actions[index];
  if (best === worst) return null;
  return action === best ? "best" : action === worst ? "worst" : null;
}

export function bestChoiceCount(actions: string[], extremes: RunExtremes) {
  return actions.filter(
    (action, i) => choiceTag(action, extremes, i) === "best",
  ).length;
}
